<script setup lang="ts">
import dayjs from 'dayjs'
import zhcn from 'dayjs/locale/zh-cn'
import { getConvertMultipleEmptyList } from '@/api/modules/home'

definePage({
  name: 'convert',
  meta: {
    title: '转多转空',
  },
})

const list = ref([]) as any
const loading = ref(false)
const finished = ref(false)
const date = dayjs().locale(zhcn).format('YYYY/MM/DD HH:MM:ss')

async function onLoad() {
  try {
    const { status, data } = await getConvertMultipleEmptyList({
      page: 1,
    })
    if (status === 1) {
      list.value = data.list
      finished.value = data.finished
    }
  }
  catch (error) {
    console.error(error)
  }
  finally {
    loading.value = false
  }
}
</script>

<template>
  <FmPageLayout navbar back class="fluctuation-page">
    <template #navbar-end>
      <FmIcon name="material-symbols:help-outline-rounded" class="text-22px color-[#fff]" />
      <FmIcon name="ri:share-forward-box-line" class="m-l-16px text-22px color-[#fff]" />
    </template>
    <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="bg-[#fff]">
        <div class="m-b-8px m-l-8px m-r-8px flex items-center justify-between text-11px">
          <div class="flex items-center color-[#999]">
            <span>更新：{{ date }}</span>
          </div>
          <div class="flex items-center justify-between gap-10px p-b-8px p-t-8px">
            <div class="flex items-center justify-between">
              <span>全部市场</span>
              <FmIcon name="material-symbols:expand-more-rounded" class="text-lg color-[#666]" />
            </div>
            <div class="flex items-center justify-between">
              <span>标记类型</span>
              <FmIcon name="material-symbols:expand-more-rounded" class="text-lg color-[#666]" />
            </div>
          </div>
        </div>
        <vxe-table
          header-row-class-name="table-header"
          :data="list"
        >
          <vxe-column field="name" title="名称" fixed="left" width="25%">
            <template #default="{ row }">
              <div class="text-15px font-500">
                {{ row.name }}
              </div>
              <div class="text-13px">
                {{ row.code }}
              </div>
            </template>
          </vxe-column>
          <vxe-column field="typeDoc" title="标记类型" width="17%">
            <template #default="{ row }">
              <div class="text-15px font-500" :style="{ color: row.type === 1 ? '#22A875' : '#E51A2D' }">
                {{ row.typeDoc }}
              </div>
            </template>
          </vxe-column>
          <vxe-column width="30%" field="date" title="标记日期" sortable />
          <vxe-column width="30%" field="prc" title="入场价" sortable />
          <vxe-column width="30%" field="prc" title="次日涨跌幅" sortable />
          <vxe-column width="30%" field="prc" title="5日涨跌幅" sortable />
          <vxe-column width="30%" field="prc" title="20日涨跌幅" sortable />
          <vxe-column width="30%" field="prc" title="至今涨跌幅" sortable align="right" />
        </vxe-table>
      </div>
    </van-list>
  </FmPageLayout>
</template>

<style lang="scss" scoped>
.fluctuation-page {
  :deep(.van-tabs__nav) {
    background-color: #f1f2f7;
  }

  :deep(.van-tab--active) {
    font-size: 17px;
  }

  .tab-conten {
    position: fixed;
    left: 0;
    z-index: 2;
    width: 100%;
  }

  .active-card {
    color: #fff;
    background-color: #3c78ff;
    border-color: #3c78ff !important;
  }
}
</style>
